import { useEffect, useMemo } from 'react';
import { atom, useAtomValue } from 'jotai';

type UseVisitHistory = {
  isNewUser: boolean;
  lastVisited: Date | null;
};

let isInitialized = false;

const FIRST_VISITED_KEY = 'geotra.first_visited';
const LAST_VISITED_KEY = 'geotra.last_visited';
const ONE_MONTH_AGO = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);

const firstVisitedAtom = atom<Date | null>(
  window.localStorage.getItem(FIRST_VISITED_KEY)
    ? new Date(window.localStorage.getItem(FIRST_VISITED_KEY)!)
    : null
);

const lastVisitedAtom = atom<Date | null>(
  window.localStorage.getItem(LAST_VISITED_KEY)
    ? new Date(window.localStorage.getItem(LAST_VISITED_KEY)!)
    : null
);

const useVisitHistory = (): UseVisitHistory => {
  // イミュータブルな状態として保存し初期化判定と合わせることで、今回の訪問でセットされた値を次回のレンダリングで参照することを防ぐ
  const firstVisited = useAtomValue(firstVisitedAtom);
  const lastVisited = useAtomValue(lastVisitedAtom);

  useEffect((): void => {
    if (!isInitialized) {
      // 初めてページを開いた時間をLocalStorageに保存する
      if (!window.localStorage.getItem(FIRST_VISITED_KEY)) {
        window.localStorage.setItem(
          FIRST_VISITED_KEY,
          new Date().toISOString()
        );
      }
      // 最後にページを開いた時間をLocalStorageに保存する
      window.localStorage.setItem(LAST_VISITED_KEY, new Date().toISOString());

      isInitialized = true;
    }
  }, []);

  const isNewUser = useMemo((): boolean => {
    return !firstVisited || ONE_MONTH_AGO <= new Date(firstVisited);
  }, [firstVisited]);

  return {
    isNewUser: isNewUser,
    lastVisited: lastVisited,
  };
};

export { useVisitHistory };
